<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .results {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    @include mixins.caption();
    @include colors.color(textGrey);

    > span {
      display: flex;
      flex-direction: row;
      gap: utils.in_rem(8px);
    }
  }

  .suggestions {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: utils.in_rem(8px);
    overflow: auto;

    span {
      @include mixins.body2();
      @include colors.color(black_90);
      &.enriching {
        @include colors.color(primary_50);
      }
    }
  }
</style>

<script>
  // Stores
  import { suggestionsStore, todoPanelStore } from "../stores";
  // Components
  import IconScale from "@sourcewhale/shared/svelte-design-system/components/atoms/IconScale.svelte";
  import AddEmail from "./AddEmail.svelte";
  import SkeletonAddEmail from "./SkeletonAddEmail.svelte";

  // messageText is used to display updates from the enriching process
  export let messageText = "";

  const { meta } = suggestionsStore;
</script>

<div class="results">
  <span>
    Results
    <IconScale class="fa-circle-info" size="xs" placement="top">
      <span slot="tooltip">
        If available, automatic email suggestions from SourceWhale will be
        displayed here at no cost.
      </span>
    </IconScale>
  </span>
  {#if $suggestionsStore.size === 1}
    1 result found
  {:else if $suggestionsStore.size > 1}
    {$suggestionsStore.size} results found
  {/if}
</div>
<div class="suggestions">
  {#if !$meta.firstFetchDone}
    <SkeletonAddEmail count={2} />
  {:else}
    {#if $suggestionsStore.size === 0}
      {#if messageText}
        <span class="enriching">{messageText}</span>
      {:else}
        <span>
          No alternative email addresses found. To continue outreach, please
          convert to InMail or remove this step.
        </span>
      {/if}
    {/if}
    {#each $suggestionsStore as email}
      <AddEmail
        onclick={() => {
          $todoPanelStore.newEmail = email;
        }}
      >
        <span>{email}</span>
      </AddEmail>
    {/each}
  {/if}
</div>
